module.exports = __webpack_public_path__ + "static/media/21.9e67e0ab.ogg";